export function messageStore() {
    return {
        banners: [],
        toasts: [],
        _idCounter: 0,

        push(messages) {
            this.banners = messages
                .filter(m => m.type === 'banner')
                .map(m => ({...m, _id: ++this._idCounter}));

            this.toasts = messages
                .filter(m => m.type === 'toast')
                .map(m => ({...m, _id: ++this._idCounter, delay: m.delay || 4000}));

        },

        removeBanner(id) {
            this.banners = this.banners.filter(b => b._id !== id);
        },

        addToast(toast) {
            this.toasts.push({...toast, _id: ++this._idCounter, delay: toast.delay || 4000});
        },

        removeToast(id) {
            this.toasts = this.toasts.filter(t => t._id !== id);
        }
    };
}